// champsCPS.js — indices des champs des blocs carte CPS (port structures_publiques_cps).
// Bloc PORTEUR : group===1. Bloc SITUATION : group===2.

// Bloc porteur
export const CPS_NUMERO_IDENT = 2; // RPPS
export const CPS_NOM = 5;
export const CPS_PRENOM = 6;

// Bloc situation d'exercice
export const CPS_NUMERO_SITUATION = 0;
export const CPS_MODE_EXERCICE = 1;
export const CPS_STATUT_EXERCICE = 2;
export const CPS_SECTEUR_ACTIVITE = 3;
export const CPS_TYPE_IDENT_STRUCTURE = 4;
export const CPS_IDENT_STRUCTURE = 5;
export const CPS_CLE_IDENT_STRUCTURE = 6;
export const CPS_RAISON_SOCIALE_STRUCTURE = 7;
export const CPS_IDENT_FACTURATION = 8;
export const CPS_CLE_IDENT_FACTURATION = 9;
export const CPS_IDENT_REMPLACE = 10;
export const CPS_CLE_IDENT_REMPLACE = 11;
export const CPS_CODE_CONVENTION = 12;
export const CPS_CODE_SPECIALITE = 13;
export const CPS_ZONE_TARIFAIRE = 14;
export const CPS_ZONE_IK = 15;
export const CPS_AGREMENT1 = 16;
export const CPS_AGREMENT2 = 17;
export const CPS_AGREMENT3 = 18;
export const CPS_HABILITATION_FSE = 19;
export const CPS_HABILITATION_LOT = 20;

// Lit Fields[i] d'un bloc en chaine nettoyee ("" si absent).
export function champ(bloc, i) {
    const f = bloc && bloc.Fields;
    return f && f[i] != null ? String(f[i]).trim() : '';
}

// Renvoie true si le bloc est une situation d'exercice (group 2).
export function estSituation(bloc) {
    return !!bloc && (bloc.group === 2 || bloc.Type === 2);
}

// Renvoie true si le bloc est le porteur (group 1).
export function estPorteur(bloc) {
    return !!bloc && (bloc.group === 1 || bloc.Type === 1);
}

// Extrait, d'un tableau de blocs CPS, la liste ordonnee des situations (group 2).
export function listeSituations(cps) {
    if (!Array.isArray(cps)) return [];
    return cps.filter(estSituation);
}

// Renvoie le porteur (group 1) ou le 1er bloc, ou null.
export function porteur(cps) {
    if (!Array.isArray(cps)) return cps && cps.Fields ? cps : null;
    return cps.find(estPorteur) || cps[0] || null;
}

// Choisit la situation active a partir d'un index 1-based (rang parmi group 2).
// Repli sur la 1re situation. null si aucune.
export function situationChoisie(cps, index) {
    const situs = listeSituations(cps);
    if (situs.length === 0) return null;
    const i = Number(index) >= 1 ? Number(index) - 1 : 0;
    return situs[i] || situs[0];
}

// Libelle court d'une situation pour la liste de la popup :
// "structure convention identFacturation NOM zoneIK".
export function libelleSituation(situ, nomPorteur) {
    return [
        champ(situ, CPS_IDENT_STRUCTURE),
        champ(situ, CPS_CODE_CONVENTION),
        champ(situ, CPS_IDENT_FACTURATION),
        (nomPorteur || '').trim(),
        champ(situ, CPS_ZONE_IK),
    ].filter(Boolean).join(' ');
}
